import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IContact } from "src/domain/entities"
import { contactDeleteService } from "src/domain/services/contact/contactDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage, getFullName } from "src/utils/helpers"

interface Props {
	contact: IContact
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ContactDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	contact,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleContactDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await contactDeleteService({ id: contact.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [contact, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Contact: ${getFullName(contact)}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleContactDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
